import Grid from 'components/Grid';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const DetailsViewEntityLinkContainer: FunctionComponent<Props> = ({
    children,
    className = '',
    testId = TEST_ID
}) => (
    <Grid className={`${className} ${styles.detailsViewEntityLinkContainer}`} testId={testId}>
        {children}
    </Grid>
);

export default DetailsViewEntityLinkContainer;
